import React,{ useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './common/Header';
import Meow from './common/Meow'; 
import Nav from './common/Navigation';
import NotificationFeed from './common/NotificationFeed';

export default function Notification({titleHead}){
	let navigate = useNavigate();
	
	useEffect(() => {
		let authToken = sessionStorage.getItem("Auth Token");
		
		if(authToken){
			navigate('/notification')
		}
		
		if(!authToken){
			navigate('/login')
		}
	}, [])
	
	return(
		<>
			<Header titleHead={titleHead}/>
			<Meow />
			<main>
				<NotificationFeed />
				<NotificationFeed />
				<h2>{titleHead} is Empty</h2>
				<p>Soooo SAD</p>
			</main>
			<Nav />
		</>
	);
}